module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1ea1995d98c06794b17b4dcfe6d13849.png";